import { LitElement, html, css } from '@hh/global.js'

class HHCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
    isGiftWrapCheckbox: {
      reflect: true,
      type: Boolean,
      attribute: 'is-gift-wrap-checkbox'
    },
    productId: {
      reflec: true,
      type: Number
    },
    lineID: {
      reflect: true,
      type: String,
      attribute: 'line-id'
    },
    lineItemValue: {
      type: Number,
      attribute: 'line-item-value'
    }
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
    if (this.isGiftWrapCheckbox) {
      this.dispatchEvent(
        new CustomEvent('handleGiftWrapFromCart', {
          bubbles: true,
          composed: true,
          detail: {
            lineID: this.lineID,
            lineItemValue: this.lineItemValue,
            productId: this.productId,
            value: this.checked
          },
        })
      )
    }
  }

  render() {
    return html`
      <div class="checkbox-container">
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
      </div>
    `
  }

  static styles = css`
    .checkbox-container {
      position: relative;
      display: inline-flex;
    }

    ::slotted(input) {
      width: var(--hh-width, 16px);
      aspect-ratio: 1;
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      border: none;
      appearance: none;
      padding: 0;
      margin: 0;
    }

    ::slotted(label) {
      position: relative;
      cursor: pointer;
      font: var(--hh-body-font-weight) var(--hh-font-size-fluid) /
        var(--hh-body-line-height) var(--hh-body-font-family);
      letter-spacing: var(--hh-body-letter-spacing);
      text-transform: var(--hh-body-text-transform);
    }

    ::slotted(label):before {
      content: '';
      -webkit-appearance: none;
      background-color: transparent;
      min-width: var(--hh-width, 16px);
      aspect-ratio: 1;
      background-color: var(--hh-color-neutral);
      position: relative;
      cursor: pointer;
      margin-right: var(--hh-space-xs);
    }

    :host {
      position: relative;
      display: inline-block;
    }

    :host([checked='true']) ::slotted(label):after {
      content: '';
      display: block;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: var(--hh-check-left, 3px);
      min-width: var(--hh-check-width, 10px);
      aspect-ratio: 1;
      background-color: var(--hh-color-brand-primary);
    }
  `
}

customElements.define('hh-checkbox-wrapper', HHCheckboxWrapper)
